import { render, staticRenderFns } from "./LeadershipConnect.vue?vue&type=template&id=0b8d4d5d&scoped=true"
import script from "./LeadershipConnect.vue?vue&type=script&lang=js"
export * from "./LeadershipConnect.vue?vue&type=script&lang=js"
import style0 from "./LeadershipConnect.vue?vue&type=style&index=0&id=0b8d4d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d4d5d",
  null
  
)

export default component.exports